import { render, staticRenderFns } from "./ImagesSlider.vue?vue&type=template&id=fd5c5876&scoped=true"
import script from "./ImagesSlider.vue?vue&type=script&lang=js"
export * from "./ImagesSlider.vue?vue&type=script&lang=js"
import style0 from "./ImagesSlider.vue?vue&type=style&index=0&id=fd5c5876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5c5876",
  null
  
)

export default component.exports